import axios from 'axios';
import store from '../store/store';
import globalAction from '../actions/global';

axios.defaults.withCredentials = true;

export class ApiBase {
    constructor(body){
        this.body = body;
    }
    url = ''
    method = 'get'
    body
    result
    exception
    headers
    fetch (){
        return Apifetch(this)
    }
}
/**
 * fetch请求数据
 * @param api 
 * @param ctx koa.Context对象，如果有ctx参数，表示在node端请求
 */
export async function Apifetch(api) {
    var { url, method, body } = api;
    // var args : any = [api.url];
    var req = {
        url,
        method
    };
    req.headers = {}
    if(api.headers){
        req.headers = api.headers;
    }
    if(api.method.toLowerCase() === 'post'){
        req.data = body;
    }else{
        if(Object.keys(api.body).length > 0){
            req.url += (req.url.indexOf('?') === -1 ? '?' : '&') + Object.keys(api.body).map(field => `${field}=${api.body[field]}`).join('&')
        }
    }
    req.url += (req.url.indexOf('?') > -1 ? '&' : '?') + `t=${new Date().valueOf()}`
    
    var result = await axios(req)
    api.result = result.data;

    // 活动过期提醒
    if (api.result && api.result.code === 213) {
        store.dispatch(globalAction.toggleOfflineModalVisible(true));
    }
    
    return api;
}